import { ImageAspectRatio } from "common/generator/components/image-types";

export enum UploadingState {
    NotUploading = 0,
    FromDropImage = 1,
    FromButton = 2
}

export function getImageAspectRatioNumber(size: ImageAspectRatio) {
    switch (size) {
        case ImageAspectRatio.Square:
        case ImageAspectRatio.Circle:
            return 1;
        case ImageAspectRatio.ThreeByTwo:
            return 2 / 3;
        case ImageAspectRatio.ThreeByOne:
            return 1 / 3;
        case ImageAspectRatio.ThreeByFour:
            return 4 / 3;
        case ImageAspectRatio.TwoByThree:
            return 3 / 2;
        case ImageAspectRatio.FourByThree:
            return 3 / 4;
    }
    return 1 / 3;
}

export function scaleImageWidthToHeight(width: number, size: ImageAspectRatio): number {
    const ratio = getImageAspectRatioNumber(size);
    return Math.round(width * ratio);
}
